<script lang="ts" setup>
import type { IconIdentifier } from '~ds/lib/icon-types';

import { Badge } from '~ds/components/ui/badge';
import { Card } from '~ds/components/ui/card';
import { Icon } from '~ds/components/ui/icon';
import { Heading, Text } from '~ds/components/ui/typography';

interface Props {
  icon: IconIdentifier;
  title: string;
  description: string;
  label: string;
}

defineProps<Props>();
</script>

<template>
  <Card
    shape="stretch"
    class="items-center px-6 py-12 text-center"
    data-testid="schools-landing-step-card"
  >
    <span
      class="flex size-20 shrink-0 items-center justify-center rounded-full bg-secondary"
      data-testid="schools-landing-step-card-icon"
    >
      <Icon :name="icon" size="2xl" />
    </span>

    <Heading
      as="h3"
      size="xl"
      data-testid="schools-landing-step-card-title"
    >
      {{ title }}
    </Heading>

    <Text
      size="md"
      class="text-muted-foreground"
      data-testid="schools-landing-step-card-description"
    >
      {{ description }}
    </Text>

    <Badge
      tone="lime"
      rounded
      data-testid="schools-landing-step-card-label"
    >
      {{ label }}
    </Badge>
  </Card>
</template>
